<template>
    <div class="snackbar-content mdl-shadow--4dp" :class="{'snackbar-hidden': !open}">
        <slot style="margin: auto"></slot>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: "Snackbar",
        props:['openCounter'],
        methods: {
            isOpen: function () {
                return open;
            }
        },
        data: function () {
          return {
              open: false,
              timeout: -1
          }
        },
        watch: {
            openCounter: function (newVal, oldVal) { // watch it
                if (newVal > oldVal) {
                    Vue.set(this, 'open', true);

                    if(this.timeout !== -1)
                        clearTimeout(this.timeout);

                    this.timeout = setTimeout(() => { Vue.set(this, 'open', false) }, 2500);
                }
            }
        }
    }
</script>

<style scoped>
    .snackbar-content {
        width: 30%;
        background-color: #333333;
        position: fixed;
        bottom: 0;
        left: 35%;
        right: 35%;
        color: white;
        padding: 1em 2em;
        font-size: large;
        z-index: 15;
        display: block;
    }

    .snackbar-hidden {
        display: none;
    }
</style>